import * as Yup from 'yup';

export const validationPermissionSchema = Yup.object({
    permissionId: Yup
        .string()
        .required("Required"),
})

export const validationTargetSchema = Yup.object({
    targetId: Yup
        .string()
        .required("Required"),
    permissions: Yup.array().of(validationPermissionSchema)
})

export const validationScopeSchema = Yup.object({
    scopeName: Yup
        .string()
        .required("Required"),
    target: Yup.array().of(validationTargetSchema)
})

export const validationSchema = Yup.object({
    routeType: Yup
        .string()
        .required("Required"),
    scopes: Yup.array().of(validationScopeSchema)
})

export const initialPermissionValues = {
    permissionId: "",
    permissionName: "",
    description: "",
    status: false
}

export const initialTargetValues = {
    targetId: "",
    targetName: "",
    description: "",
    permissions: []
}

export const initialScopeValues = {
    scopeId: "",
    scopeName: "",
    description: "",
    target: []
}

export const initialValues = {
    routeType: "",
    selected: [],
    scopes: []
}